// extracted by mini-css-extract-plugin
export default {"wrapper":"TllnZ","youngTariffFloatingButton":"twDWW","buttonsGroup":"wZRp"};